<template>
    <div class="container">
        <home-common-search :value="params.keyword"></home-common-search>
        <goodslist-body></goodslist-body>
    </div>
</template>

<script>
import HomeCommonSearch from '../common/HomeCommonSearch'
import GoodslistBody from './GoodslistBody'
export default {
  name: 'HomeGoodslist',
  components: {
    HomeCommonSearch,
    GoodslistBody
  },
  data () {
    return {
      params: {
        keyword: this.$route.query.keywords ? this.$route.query.keywords : ''
      }

    }
  },
  beforeRouteLeave(to, from, next) { 
      if(to.name == 'HomeGoodsdetail'){
          from.meta.keepAlive = true;
      }else{
          from.meta.keepAlive = false;
      }
    next();
  },
  created () {

  }
}
</script>

<style scoped lang="scss">

</style>
